import { ESMenuItem, useESMenuContext } from '@energy-stacks/core/ui';
import { useDialog } from '@energy-stacks/shared';
import { useTranslation } from 'react-i18next';
import { DeleteTourDialog } from './DeleteTourDialog';
import { OptimizedTourModel } from '@energy-stacks/fleet/feature-tours-data';

type DeleteTourMenuItemProps = {
  tourId: OptimizedTourModel['id'];
  tourStatus: OptimizedTourModel['status'];
};

export const DeleteTourMenuItem: React.FC<DeleteTourMenuItemProps> = ({
  tourId,
  tourStatus,
}) => {
  const [t] = useTranslation('tours');
  const {
    open,
    dialogProps: { isOpen, onClose },
  } = useDialog();
  const { closeESMenu } = useESMenuContext();

  return (
    <>
      <ESMenuItem
        testId={`${tourId}DeleteMenuItem`}
        onClick={() => {
          closeESMenu();
          open();
        }}
      >
        {t('deleteTourCTA')}
      </ESMenuItem>
      <DeleteTourDialog
        isOpen={isOpen}
        onClose={onClose}
        tourId={tourId}
        tourStatus={tourStatus}
      />
    </>
  );
};
